import { createSlice } from 'utils/@reduxjs/toolkit';
import { ShapeVisualizationState } from './types';
import { reducers } from './reducers';

export const initialState: ShapeVisualizationState = {
  shape: (function () {
    const storage = localStorage.getItem('formInitialValues');
    const storageObj = JSON.parse(storage || '{}');
    if (storageObj.shapeUsed) {
      return storageObj.shapeUsed;
    }
    localStorage.setItem(
      'formInitialValues',
      JSON.stringify({ ...storageObj, shapeUsed: 'ring' }),
    );
    return 'ring';
  })(),
  fieldFocused: 'outerDiameter',
};

const slice = createSlice({
  name: 'shapeVisualization',
  initialState,
  reducers,
});

export const { actions: shapeVisualisationActions } = slice;
export const { reducer: shapeVisualizationReducer } = slice;
